module.exports = __webpack_public_path__ + "img/Frostbitten_Horn.087e5493.png";